export default "__VITE_ASSET__0066530b__"